import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { closePopup } from '../../actions/uiActions'
import checkCircle from '../../images/js/checkCircle'
import cancelCircle from '../../images/js/cancelCircle'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

class ConfirmationPopup extends React.Component {

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    componentDidMount() {
        setTimeout(this.props.closePopup, 5000)
    }

    render() {
        return (<div className="loaderDialog">
            <Dialog
                open={true}
                maxWidth="sm"
                fullwidth="true"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <div className="loaderIcon">
                        <p>{this.props.popupInfo}</p>
                        {(this.props.popupFlag) ? checkCircle("#1A9ADB", "96px") : cancelCircle("#1A9ADB", "96px")}
                    </div>
                </DialogContent>
            </Dialog>
        </div>)
    }
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        popupFlag: state.ui.popupFlag,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPopup)